"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = splitVatNumber;

function splitVatNumber(fullVatNumber) {
  var countryCode = (fullVatNumber || '').substring(0, 2);
  var vatNumber = (fullVatNumber || '').substring(2);
  return [countryCode, vatNumber];
}